import { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

function Leads() {
  const [properties, setProperties] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [notFoundMessage, setNotFoundMessage] = useState("");

  const [leads, setLeads] = useState([]);
  const axiosAPI = useAxios();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    address: "",
    message: "",
    status: "",
    propertyName: "",
  });

  const removeFormData = () => {
    setFormData({
      fullName: "",
      phoneNumber: "",
      email: "",
      address: "",
      message: "",
      status: "",
      propertyName: "",
    });
  };

  const [filters, setFilters] = useState({
    status: "",
    from_date: "",
    to_date: "",
  });

  // Handler to update filters
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Get All Notifications
  const getProperty = async () => {
    try {
      const response = await axiosAPI.get("/api/properties/get-properties");
      // console.log(response.data);
      setProperties(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getLeads = async () => {
    try {
      setLoading(true);

      const response = await axiosAPI.get(`/api/leads/all?page=${page}`);
      const { success, leads } = response.data;

      if (success && Array.isArray(leads)) {
        setLeads(leads);
        setTotalPages(response?.data?.totalPages);
        // setTotalRecords(totalRecords);
        setNotFoundMessage(leads.length === 0 ? "No leads found." : "");
      } else {
        setLeads([]);
        setNotFoundMessage("No leads found.");
      }
    } catch (err) {
      console.error("Error fetching leads:", err);
      setLeads([]);
      if (err.response?.status === 404) {
        setNotFoundMessage("No leads found.");
      } else {
        setNotFoundMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  // console.log(statusList);

  useEffect(() => {
    getProperty();
  }, []);

  useEffect(() => {
    getLeads();
  }, [page]);

  // Handle Input Changes
  const handleChange = (e) => {
    console.log(e.target.id, e.target.value);
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      full_name: formData.fullName,
      phone_number: formData.phoneNumber,
      email: formData.email,
      address: formData.address,
      selected_property: formData.propertyName,
      status: formData.status,
      message: formData.message,
    };

    console.log(payload);
    setIsLoading(true);

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/enquiries/update-enquiry/${currentUserId}`,
          payload,
        );
        window.notifyMessage(
          "Success",
          "Enquiry updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post("/api/enquiries/add-enquiry", payload);

        window.notifyMessage(
          "Success",
          "Enquiry added successfully",
          "success",
        );
      }
      hideModal("newUserModal");
      getLeads();
      removeFormData();
      setIsEditMode(false);
      setIsLoading(false);
      // window.location.reload(); // Reload page to reflect changes in the Property list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);
    console.log(id);

    // Find the notification with this ID and populate the form
    const selectedProperty = enquiries.find((enq) => enq.id === id);
    console.log("Open edit modal", selectedProperty);
    if (selectedProperty) {
      setFormData({
        fullName: selectedProperty.full_name,
        email: selectedProperty.email,
        phoneNumber: selectedProperty.phone_number,
        address: selectedProperty.address,
        message: selectedProperty.message,
        status: selectedProperty.status,
        propertyName: selectedProperty.selected_property,
      });
    }

    const modal = new window.bootstrap.Modal(
      document.getElementById("newUserModal"),
    );
    modal.show();
  };

  // console.log(enquiries)

  const handleDelete = async (id) => {
    console.log(id);
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/leads/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      getLeads();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newUserModal");
  };

  const formatCreatedAt = (value) => {
    if (!value) return "-";

    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) return "-";

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          {/* <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Lead
            </button>
          </div> */}
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Enquiry" : "Add Enquiry"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Property Name (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="fullName" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fullName"
                      placeholder="Enter Your Name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Phone Number Field (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="phoneNumber" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phoneNumber"
                      placeholder="Enter Phone Number"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Email (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      placeholder="Enter Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Address (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      placeholder="Enter Thumbnail Url"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Message Url (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="message"
                      placeholder="Enter Message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Select Property */}
                  <div className="mb-3">
                    <label htmlFor="propertyName" className="form-label">
                      Select Property
                    </label>
                    <select
                      className="form-select"
                      id="propertyName"
                      name="propertyName"
                      required
                      value={formData.propertyName}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Property Type
                      </option>
                      {properties.map((option) => (
                        <option key={option.id} value={option.value}>
                          {option.property_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Select Status Type  */}
                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">
                      Select Status
                    </label>
                    <select
                      className="form-select"
                      id="status"
                      name="status"
                      required
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Status Type
                      </option>
                      {statusList?.length > 0 &&
                        statusList.map((statusList) => (
                          <option
                            key={statusList?.id}
                            value={statusList?.value}
                          >
                            {statusList?.status}
                          </option>
                        ))}
                    </select>
                  </div>
                  {/* 
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode ? "Update Enquiry" : "Add Enquiry"}
                  </button> */}
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                    disabled={isLoading} // Disable button while isLoading
                  >
                    {isLoading ? (
                      <FaSpinner className="spinner" spin /> // Loader icon from react-icons
                    ) : isEditMode ? (
                      "Update Enquiry"
                    ) : (
                      "Add Enquiry"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Notification Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left Section - User Details */}
                <div className="d-flex align-items-center">
                  <h4 className="card-title mb-0">
                    All Leads ({leads.length})
                  </h4>
                </div>

                {/* Right Section - Filters */}
                {/* <div className="d-flex gap-3 flex-wrap ">
                  Status Dropdown
                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Status</label>
                    <select
                      className="form-select"
                      value={filters.status}
                      onChange={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                      style={{ width: "100%" }}
                    >
                      <option value="">All Status</option>
                      <option value="new">New</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="interested">Interested</option>
                    </select>
                  </div>

                  From Date
                  <div className="d-flex flex-column">
                    <label htmlFor="fromDate" className="form-label mb-1">
                      From
                    </label>
                    <input
                      id="fromDate"
                      type="date"
                      className="form-control"
                      value={filters.from_date || ""}
                      onChange={(e) =>
                        handleFilterChange("from_date", e.target.value)
                      }
                    />
                  </div>

                  To Date
                  <div className="d-flex flex-column">
                    <label htmlFor="toDate" className="form-label mb-1">
                      To
                    </label>
                    <input
                      id="toDate"
                      type="date"
                      className="form-control"
                      value={filters.to_date || ""}
                      onChange={(e) =>
                        handleFilterChange("to_date", e.target.value)
                      }
                    />
                  </div>

                  Filter Button
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-primary rounded-pill px-4 mt-2 mt-md-4"
                      style={{ height: "38px" }}
                      onClick={() => {
                        if (
                          filters.status ||
                          filters.from_date ||
                          filters.to_date
                        ) {
                          getLeads();
                        } else {
                          alert("Please select both From and To dates.");
                        }
                      }}
                    >
                      Filter
                    </button>
                  </div>
                </div> */}
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Phone Number</th>
                        <th>Email</th>
                        <th>Property Name</th>
                        <th>Message</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Show a loading state when data is being fetched
                        <tr>
                          <td colSpan="9" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : notFoundMessage ? (
                        <tr>
                          <td colSpan="6" className="text-center text-danger">
                            {notFoundMessage}
                          </td>
                        </tr>
                      ) : leads.length == 0 ? (
                        // Show a "No Data Found" message when no data is available
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        // Render the list of leads if data is available
                        leads.map((lead) => {
                          // Check if the message length is greater than 50 characters and truncate it
                          //   const truncatedMessage =
                          //     lead.message.length > 50
                          //       ? lead.message.slice(0, 50) + "..."
                          //       : lead.message;

                          // created_at store in ISO format, we need to convert it to a more readable format

                          return (
                            <tr key={lead.id}>
                              <td>{lead.full_name}</td>
                              <td>{lead.phone_number}</td>
                              <td>{lead.email}</td>
                              <td>{lead.property_name}</td>
                              <td>{lead.message}</td>
                              <td>{formatCreatedAt(lead?.created_at)}</td>
                              <td>
                                {/* <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(lead.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button> */}
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(lead.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leads;
